import { relative } from "path";
import React, { CSSProperties, PropsWithChildren } from "react";

interface TextPaneProps {
    title: String
}

const GLOBALSTYLES: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

const BACKDROPSTYLE: CSSProperties = {
    height: '100vh',
    width: '100%',
    position: 'fixed',
    backgroundColor: '#00000073',
}

const PANESTYLES: CSSProperties = {
    maxWidth: '75%',
    width: 450,
    height: 'auto',
    backgroundColor: 'rgba(3, 44, 78, 1)',
    color: 'white',
    position: 'relative',
    zIndex: 100,
    borderRadius: 10,
    padding: '2rem',
    overflowX: 'hidden',
}

const TITLESTYLES: CSSProperties = {
    fontSize: 24,
    fontFamily: "sans-serif",
    marginBottom: 16,
}

const TextPane: React.FC<PropsWithChildren<TextPaneProps>> = (props) => {
    return(
        <div style={GLOBALSTYLES}>
            <div style={BACKDROPSTYLE}></div>
            <section style={PANESTYLES}>
                <h1 style={TITLESTYLES}>{props.title}</h1>
                {props.children}
            </section>
        </div>
    );
}

export default TextPane